// import defaultTheme from 'tailwindcss/defaultTheme'

import plugin from 'tailwindcss/plugin'

const fontSizeBase = 16

/** @type {import('tailwindcss').Config} */
export default {
  mode: 'jit',
  // important: '#app',
  content: [
    './storage/framework/views/*.php',
    './resources/views/**/*.blade.php',
    './resources/js/**/*.{js,jsx,ts,tsx}',
  ],
  corePlugins: {
    preflight: false,
  },
  theme: {
    extend: {
      colors: {
        bosch: {
          DEFAULT: '#ed1c24',
        },
        siemens: {
          DEFAULT: '#009999',
        },
        zelmer: {
          DEFAULT: '#1555fd',
        },
        danger: {
          DEFAULT: '#ff0000',
        },
      },
    },
    fontFamily: {
      sans: ['Helvetica Neue', 'Helvetica', 'Arial', 'sans-serif'],
    },
    fontSize: {
      xs: `${12 / fontSizeBase}rem`,
      sm: `${14 / fontSizeBase}rem`,
      base: '1rem',
      md: `${18 / fontSizeBase}rem`,
      lg: `${22 / fontSizeBase}rem`,
      xl: `${26 / fontSizeBase}rem`,
    },
    fontWeight: {
      light: 300,
      normal: 400,
      medium: 500,
      bold: 700,
    },
    screens: {
      // xs: '0px',
      sm: '600px',
      md: '900px',
      lg: '1200px',
      xl: '1536px',
    },
    spacing: {
      0: '0rem', // 0px
      1: '0.5rem', // 8px
      2: '1rem', // 16px
      3: '1.5rem', // 24px
      4: '2rem', // 32px
      5: '2.5rem', // 40px
      6: '3rem', // 48px
      7: '3.5rem', // 56px
      8: '4rem', // 64px
      9: '4.5rem', // 72px
      10: '5rem', // 80px
    },
  },
  plugins: [
    plugin(function ({ addUtilities /* , theme */ }) {
      const newUtilities = {
        '.y-center': {
          display: 'flex',
          alignItems: 'center',
        },
        '.x-center': {
          display: 'flex',
          justifyContent: 'center',
        },
        '.xy-center': {
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        },
      }
      addUtilities(newUtilities)
    }),
  ],
}
